// EP-150 (App Review 5.1.1v): /account/delete, docs/ep-150-app-store-review.md §3.
export default {
  delete: {
    title_account: 'Delete account',
    title_user: 'Delete my login',

    loading: 'Loading…',
    load_error: 'Could not load your account status. Please try again.',

    what_heading: 'What will be deleted',
    what_account:
      'Every building, room, tenant, lease, invoice, payment, expense, accounting entry, document and uploaded file of this account, and every team member’s login. Tenants lose access to the customer app.',
    what_user: 'Only your own login. The account and its data stay.',

    when_heading: 'When',
    when_body: 'It stops working at once. It can be restored until the end of {{date}}, and is erased for good after that.',

    restore_heading: 'How to restore',
    restore_body: 'Sign in with the same email and password within {{days}} days and choose Restore.',
    restore_owner_only: 'Only an owner can restore the account.',

    kept_heading: 'What FlowRent keeps',
    kept_body:
      'FlowRent’s own billing records for this account, which the law requires it to keep, and the record of changes made to the account’s name and settings.',

    closing_package_suggestion: 'Consider downloading the month-end package first.',
    closing_package_link: 'Go to the closing package',

    password_label: 'Confirm your password',
    password_placeholder: 'Enter your password',
    toggle_password_visibility: 'Show or hide password',
    password_required: 'Enter your password to continue.',

    submit_account: 'Delete account',
    submit_user: 'Delete my login',

    confirm_title_account: 'Delete this account?',
    confirm_title_user: 'Delete your login?',
    confirm_message_account:
      'The account stops working now, for every team member and every tenant. It is erased for good after {{days}} days and cannot be restored after that.',
    confirm_message_user:
      'Your login stops working now. It is erased for good after {{days}} days and cannot be restored after that.',
    confirm_confirm: 'Delete',
    confirm_cancel: 'Cancel',

    errors: {
      password_invalid: 'That password is not correct.',
    },
  },

  export: {
    title: 'Your account data',
    lead: 'Download each file below. Each link works for 15 minutes; reload this page for new links.',
    links_expire: 'Links expire after 15 minutes.',
    files_deleted_on: 'The files are deleted on {{date}}.',
    not_owner: 'Only the account owner can download this export.',
    link_invalid: 'This link is not valid or has expired. Ask FlowRent support for a new export.',
    expired: 'This export has been deleted. Ask FlowRent support for a new export.',
    load_error: 'Could not load the export. Please try again.',
  },
}
